import { findAndReplace } from '../../../utils/arrayModify';

export function handleUpdateStateWithUploadDoc(state, action) {
  const target = state.list.find(
    ({ id }) => action.payload.userAppointmentId === id,
  );

  if (target) {
    target.documents.push(action.payload);
    return {
      ...state,
      list: findAndReplace(state.list, {
        ...target,
      }),
    };
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/components/Healthboard/utils/handleUpdateStateWithUploadDoc.js